import { Modal } from "antd";
import React, { useState } from "react";
import { triggerRequest } from "../../triggerRequest";
import { ModalStatusDelete } from "../../../../../Utils/modalStatus";

export const ModalDelete = ({ visible, onCancel, id, estadoTrigger }) => {
  const [loading, setLoading] = useState(false);
  const [openModalStatus, setOpenModalStatus] = useState(false);

  const deletarTrigger = async () => {
    setLoading(true);
    try {
      const response = await triggerRequest.deleteTrigger(id);
      if (response.status === 204) {
        estadoTrigger((prevState) =>
          prevState.filter((triggerValue) => {
            return triggerValue.id !== id;
          })
        );
        onCancel();
        setOpenModalStatus(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onCancel}
        onOk={deletarTrigger}
        confirmLoading={loading}
      >
        <text style={{ fontWeight: "500", fontSize: 16 }}>
          Deseja deletar esta Trigger?
        </text>
      </Modal>

      <ModalStatusDelete
        onCancel={() => setOpenModalStatus(false)}
        visible={openModalStatus}
      />
    </>
  );
};
